import { render } from "./ReferralTransaction.vue?vue&type=template&id=42c3f6b6&scoped=true"
import script from "./ReferralTransaction.vue?vue&type=script&lang=js"
export * from "./ReferralTransaction.vue?vue&type=script&lang=js"

import "./ReferralTransaction.vue?vue&type=style&index=0&id=42c3f6b6&scoped=true&lang=css"

import exportComponent from "/Users/afolabitope/Documents/apps/redge/web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42c3f6b6"]])

export default __exports__